function userInfoReducer(state = {}, action) {
  switch (action.type) {
    case 'USER_INFO_CREATED':
      let { userName = '', emailId = '' } = action;
      let userInfoStore = { ...state, userName };
      return userInfoStore;
      break;
    default:
      return state;
  }
}

export default userInfoReducer;
